export class OrderReprocessDto {
    constructor(
        public poId: number,
        public docId: number ,
        public fileId: number,
        public newFileName: string,
        public uniqueIdentificationText: string,
        public poType: string,
        public poNumber: string,
        public bolReprocess: number,
        public supplierDocReferenceNumber: string,
        public fileArchivalId: string
    ){}
}
